import classnames from 'classnames/bind'
import React from 'react'

import Image, { ImageProps } from '~/components/Image'
import ImageWithPlaceHolder from '~/components/ImageWithPlaceholder'
import RichText, { RichTextBlock } from '~/components/RichText'

import { useStyle } from '~/providers/StyleProvider'

import css from './styles.module.scss'

const cx = classnames.bind(css)

export interface GridItemProps {
  className?: string
  image?: ImageProps
  title?: RichTextBlock[]
  text?: RichTextBlock[]
}

function GridItem({ className, image, title, text }: GridItemProps) {
  const titleStyle = useStyle({ textPreset: 'title-content-section' })
  const textStyle = useStyle({ textPreset: 'text-paragraph' })

  return (
    <div className={cx(css.GridItem, className)}>
      <div className={css.content}>
        {image && (
          <div className={css.imageContainer}>
            <ImageWithPlaceHolder
              className={css.image}
              layout="fill"
              objectFit="contain"
              {...image}
            />
          </div>
        )}
        {title && (
          <RichText className={cx(css.title, titleStyle)} render={title} />
        )}
        {text && <RichText className={cx(css.text, textStyle)} render={text} />}
      </div>
    </div>
  )
}

GridItem.defaultProps = {}

export default GridItem
